import { usePredictionMarketCategories } from '@/lib/endpoints';

export interface CategoryMeta {
  /** Human category name (falls back to the code when the API has none). */
  displayName: string;
  /** Category icon URL, when configured in admin. */
  iconImgUrl: string | null;
}

/**
 * Resolves a category code to its display name + icon from the shared
 * `usePredictionMarketCategories` cache (same dedup pattern as
 * `CategoryBanner`). Used by the lobby V2 card eyebrow ("Elections – U.S.
 * Elections" + icon). Returns `undefined` while categories are loading or
 * for an unknown code.
 */
export function useCategoryMeta(categoryCode: string | null | undefined): CategoryMeta | undefined {
  const { data } = usePredictionMarketCategories();
  if (!categoryCode) return undefined;
  const cat = (data ?? []).find((c) => c.code === categoryCode);
  if (!cat) return undefined;
  return { displayName: cat.displayName ?? cat.code, iconImgUrl: cat.iconImgUrl ?? null };
}
